import { connect } from "react-redux";
import ApprovalPmSites from "./approvalPmSites";
import { bindActionCreators } from "redux";
import { fetchPmSities, fetchMonth, downloadPMList, uploadPmList,postApprovePmSite,getPmSitiesFilterDropDown,postRejectPmSite  } from "services/redux/maintenance/pmSities/action";

const mapStateToProps = (state) => ({
  pmSitiesData: state.pmSitiesReducer.pmSitiesData,
  maintenanceMonth: state.pmSitiesReducer.maintenanceMonth,
  downloadPmList: state.pmSitiesReducer.downloadPmList,
  pmdropdownList: state.pmSitiesReducer.pmdropdownList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchPmSities,
      fetchMonth,
      downloadPMList,
      uploadPmList,
      postApprovePmSite,
      postRejectPmSite,
  getPmSitiesFilterDropDown,

    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalPmSites);
